import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { confirmSignup, resendConfirmCode } from './cognitoUtils';

//Verify account page
const Verifyaccount = () => {
  const navigate = useNavigate(); 
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const username = queryParams.get('username')
  const password = location.state?.password;
  const [code, setCode] = useState('');
  const [message, setMessage] = useState('');

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      await confirmSignup(username, password, code);
      setMessage('Verify account successful!');
      navigate('/auth'); 
    } catch (error) {
      setMessage(error.message);
    }
  };

  // console.log(username)
  if (!username) {
    navigate('/auth');
    return null;
  }

  return (
    <div className="wrapper">
      <div className="title-text">
        <div className={'title'}>
          Verify Account
        </div>
      </div>
      <div className="form-container">
        <div className="form-inner">
          <form onSubmit={handleSignup} className="login">
            <div className="field">
              <input
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="Code"
                required
              />
            </div>
            <div className="error-message">
              <p>{message}</p>
            </div>
            <div className="field btn">
              <div className="btn-layer"></div>
              <input type="submit" value="Confirm" />
            </div>
            <div className="signup-link">
              <a href="#" onClick={()=>resendConfirmCode(username)}>
                Re-send Code
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Verifyaccount;
